var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHealthStatus)?_c('issue-health-status',{staticClass:"gl-text-nowrap",class:{
    '@md/panel:gl-border-r @md/panel:gl-mr-3 @md/panel:gl-border-gray-100 @md/panel:gl-pr-3':
      _vm.hasUpdateTimeStamp,
  },attrs:{"display-as-text":"","text-size":"sm","health-status":_vm.healthStatus}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }